import React, { useCallback } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroupMaterial from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import clsx from 'clsx';
import useStyles from './styles';
import { RadioOption } from './types';

type Props = {
  label?: string;
  disabled?: boolean;
  options: RadioOption[];
  blockedIds?: string[];
  onChange: (val: string) => void;
  value: string;
  direction?: 'vertical' | 'horizontal';
};

const RadioGroup = ({
  label,
  options,
  blockedIds,
  value,
  onChange,
  direction = 'vertical',
}: Props) => {
  const classes = useStyles();

  const handleChange = useCallback((event) => {
    onChange(event.target.value);
  }, [onChange]);


  const renderLabel = useCallback((labelText: string, description?: string) => {
    if (description) {
      return (
        <div>
          <div>{labelText}</div>
          <div className={classes.labelDescription}>{description}</div>
        </div>
      );
    }
    return labelText;
  }, [classes]);

  return (
    <FormControl component="fieldset">
      {label && (<FormLabel component="legend">{label}</FormLabel>)}
      <RadioGroupMaterial
        value={value}
        className={clsx(classes.radioGroup, {
          [classes.radioGroupHorizontal]: direction === 'horizontal',
        })}
      >
        {options.map((option) => (
          <div key={option.id}>
            <FormControlLabel
              value={option.id}
              control={(
                <Radio
                  disabled={blockedIds && blockedIds.includes(option.id as never)}
                  classes={{
                    root: clsx(classes.radioRoot, { [classes.radioRootWithDesc]: Boolean(option.description) }),
                  }}
                  checked={value === option.id}
                />
              )}
              label={renderLabel(option.label, option.description)}
              onChange={handleChange}
              classes={{
                root: clsx(classes.labelRoot, { [classes.labelRootWithDesc]: Boolean(option.description) }),
                label: classes.label,
              }}
            />
          </div>
        ))}
      </RadioGroupMaterial>
    </FormControl>
  );
};
export default RadioGroup;
